// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Tooltip from 'vue-directive-tooltip'
import 'vue-directive-tooltip/css/index.css'

import '@/assets/css/container_sections.css'
import '@/assets/css/links.css'

Vue.config.productionTip = false

Vue.use(Tooltip)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js